export default __webpack_public_path__ + "static/media/element_68.ed2ec835.webp";